"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
exports.__esModule = true;
exports.IOperatorFilterRegistry__factory = void 0;
var ethers_1 = require("ethers");
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address"
            },
        ],
        name: "codeHashOf",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address"
            },
            {
                internalType: "address",
                name: "registrantToCopy",
                type: "address"
            },
        ],
        name: "copyEntriesOf",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256"
            },
        ],
        name: "filteredCodeHashAt",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address"
            },
        ],
        name: "filteredCodeHashes",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "",
                type: "bytes32[]"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256"
            },
        ],
        name: "filteredOperatorAt",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address"
            },
        ],
        name: "filteredOperators",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "codeHash",
                type: "bytes32"
            },
        ],
        name: "isCodeHashFiltered",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address"
            },
            {
                internalType: "address",
                name: "operatorWithCode",
                type: "address"
            },
        ],
        name: "isCodeHashOfFiltered",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
        ],
        name: "isOperatorAllowed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
        ],
        name: "isOperatorFiltered",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address"
            },
        ],
        name: "isRegistered",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address"
            },
        ],
        name: "register",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address"
            },
            {
                internalType: "address",
                name: "registrantToCopy",
                type: "address"
            },
        ],
        name: "registerAndCopyEntries",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address"
            },
            {
                internalType: "address",
                name: "subscription",
                type: "address"
            },
        ],
        name: "registerAndSubscribe",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address"
            },
            {
                internalType: "address",
                name: "registrantToSubscribe",
                type: "address"
            },
        ],
        name: "subscribe",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256"
            },
        ],
        name: "subscriberAt",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address"
            },
        ],
        name: "subscribers",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address"
            },
        ],
        name: "subscriptionOf",
        outputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address"
            },
        ],
        name: "unregister",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address"
            },
            {
                internalType: "bool",
                name: "copyExistingEntries",
                type: "bool"
            },
        ],
        name: "unsubscribe",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "codehash",
                type: "bytes32"
            },
            {
                internalType: "bool",
                name: "filtered",
                type: "bool"
            },
        ],
        name: "updateCodeHash",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address"
            },
            {
                internalType: "bytes32[]",
                name: "codeHashes",
                type: "bytes32[]"
            },
            {
                internalType: "bool",
                name: "filtered",
                type: "bool"
            },
        ],
        name: "updateCodeHashes",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "filtered",
                type: "bool"
            },
        ],
        name: "updateOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address"
            },
            {
                internalType: "address[]",
                name: "operators",
                type: "address[]"
            },
            {
                internalType: "bool",
                name: "filtered",
                type: "bool"
            },
        ],
        name: "updateOperators",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
];
var IOperatorFilterRegistry__factory = /** @class */ (function () {
    function IOperatorFilterRegistry__factory() {
    }
    IOperatorFilterRegistry__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    IOperatorFilterRegistry__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    IOperatorFilterRegistry__factory.abi = _abi;
    return IOperatorFilterRegistry__factory;
}());
exports.IOperatorFilterRegistry__factory = IOperatorFilterRegistry__factory;
